module.exports = {

    props: {
        url: {
            type: String,
            required: true,
        },
        video: {
            type: Object,
            required: true,
        },
        serie: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            player: null,
        }
    },

    mounted() {
        if(!this.authorize('admin')){
            $(document).bind("contextmenu", function (ev) {
                return false;
            });
        }

        this.player = VideoJs('video-player', {
            playbackRates: [.5, .75, 1, 1.25, 1.5]
        });

        this.player.on('playing', () => {
            var storageKey = `watched-video-${this.video.id}`;
            if (!Storage.get(storageKey)) {
                axios.put(`/training/series/${this.serie.slug}/videos/${this.video.id}`).then(response => {
                    Storage.set(storageKey, true)
                })
            }
        });
    },
}
